export const mappingFieldsForArticle = {
    "VehicleId": {
        "value": "Vehicle ID",
        "width": "200px"
    },
    "VehicleCount": {
        "value": "Vehicle Count",
        "width": "200px"
    },
    "Make": {
        "value": "Manufacturer",
        "width": "200px"
    },
    "MakeId": {
        "value": "Manufacturer ID",
        "width": "200px"
    },
    "ModelId": {
        "value": "Model ID",
        "width": "200px"
    },
    "Model": {
        "value": "Model Name",
        "width": "200px"
    },
    "Variant": {
        "value": "Variant",
        "width": "200px"
    },
    "EngineCode": {
        "value": "Engine Code",
        "width": "200px"
    },
    "FromDate": {
        "value": "From Date",
        "width": "200px"
    },
    "ToDate": {
        "value": "To Date",
        "width": "200px"
    },
    "ABENr": {
        "value": "ABENr",
        "width": "200px"
    },
    "PowerPS": {
        "value": "Power (PS)",
        "width": "200px"
    },
    "PowerkW": {
        "value": "Power (kW)",
        "width": "200px"
    },
    "CapacityCCM": {
        "value": "Technical Capacity",
        "width": "250px"
    },
    "Capacity": {
        "value": "Capacity",
        "width": "200px"
    },
    "NumberOfValves": {
        "value": "Number of Valves",
        "width": "200px"
    },
    "NoOfCylinders": {
        "value": "Number of Cylinders",
        "width": "200px"
    },
    "BodyType": {
        "value": "Body Type",
        "width": "200px"
    },
    "DriveType": {
        "value": "Drive Type",
        "width": "200px"
    },
    "FuelType": {
        "value": "Fuel Type",
        "width": "200px"
    },
    "FuelMixture": {
        "value": "Fuel Mixture",
        "width": "200px"
    },
    "KBANumber": {
        "value": "KBA Number",
        "width": "200px"
    },
}